import { FC } from 'react';
import styled from 'styled-components';

import Button, { ButtonProps } from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';

export const Title = styled(Heading).attrs({
  'aria-level': 1,
  role: 'heading',
  size: 'lg',
})`
  display: block;
  line-height: 44px;
  margin-bottom: ${({ theme }) => theme.spacings.abs24}px;
`;

export const Subtitle = styled(Text).attrs({
  'aria-level': 2,
  fontWeight: 'weight-500',
  role: 'heading',
  size: 'lg',
  variant: 'primary',
})`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacings.abs16}px;
`;

export const CTAButton: FC<ButtonProps> = (props) => (
  <Button isExpanded marginTop="space-32" {...props} />
);
